import React, { memo } from "react";
import { defaultLogo } from "../../../ThirdScreen/qrSettings/logotypeQr/svg";
import { useDispatch, useSelector } from "react-redux";
import { updateBuilderSocialLinks } from "../../../../redux/slices/linksBuilder";
import styled from "styled-components";
import classNames from "classnames";
import { Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { CloseIcon } from "../svg";
import { validLinkPattern } from "../../../../RegExpValidations";
import { setIsLogoModal } from "../../../../redux/slices/modals";
import ModalLogo from "../../../../components/modals/modalLogo";

const LINK_LENGTH = 2000;

export default memo(function SocialLinks({ error, handleLinkValidate }) {
  const { lang, configData, isLogoModal, langLogo } = useSelector((state) => ({
    lang: state.changeLang.language.stepTwo.linkList || [],
    configData: state.linksBuilder.data,
    isLogoModal: state.modals.isLogoModal,
    langLogo: state.changeLang.language.stepThree.logo,
  }));

  const dispatch = useDispatch();

  const handleChangeText = (id, value) => {
    let string = value.trim();
    const validate = validLinkPattern.test(string);
    if (validate) {
      handleLinkValidate(!validate || string.length > LINK_LENGTH);
      if (!/^.+:\/\//.test(string)) {
        string = `http://${string}`;
      }
    }
    const updateData = configData.socials.map((social) =>
      social.id === id ? { ...social, link: string } : social
    );
    dispatch(updateBuilderSocialLinks(updateData));
  };

  const handleViewMore = () => {
    dispatch(setIsLogoModal(true));
  };

  const setLogo = (id) => {
    dispatch(
      updateBuilderSocialLinks([...configData.socials, { id, link: "" }])
    );
  };

  const addSocialLink = () => (
    <>
      {configData.socials.map((item) => {
        const currentLogo = defaultLogo.find((logo) => logo.id === item.id);
        return (
          <Row
            className="align-items-center flex-nowrap position-relative mt-3"
            key={item.id}
          >
            <Col xs={12}>
              <div className="position-relative">
                <FloatingLabel
                  label={lang[13]}
                  className={classNames("", {
                    label_prefix: true,
                  })}
                >
                  <Form.Control
                    placeholder={lang[13]}
                    type="text"
                    name="title"
                    value={item.link}
                    onChange={(e) => handleChangeText(item.id, e.target.value)}
                    className={classNames("pe-5 pe-md-2", {
                      "border-danger":
                        (error && !item.link.trim()) ||
                        (error && item.link.length > LINK_LENGTH) ||
                        (!validLinkPattern.test(item.link.trim()) &&
                          item.link.length > 3),
                      "border-success":
                        !error &&
                        validLinkPattern.test(item.link.trim()) &&
                        item.link.length > 3,
                      prefix: true,
                      "error-field": !validLinkPattern.test(item.link.trim()),
                    })}
                  />
                </FloatingLabel>
                <Logo className="top-50 left-0 position-absolute translate-middle-y ms-3">
                  <img
                    src={currentLogo.img}
                    className="img-fluid"
                    width="16"
                    height="16"
                  />
                </Logo>
                <Logo
                  className="top-50 end-0 position-absolute translate-middle-y me-3"
                  onClick={() =>
                    dispatch(
                      updateBuilderSocialLinks(
                        configData.socials.filter(
                          (social) => social.id !== item.id
                        )
                      )
                    )
                  }
                >
                  <CloseIcon />
                </Logo>
              </div>

              {error && !item.link.trim() && (
                <Form.Text className="text-danger">{lang[23]}</Form.Text>
              )}
              {error && item.link.length > LINK_LENGTH && (
                <Form.Text className="text-danger">{lang[25]}</Form.Text>
              )}
              {!validLinkPattern.test(item.link.trim()) &&
                item.link.length > 3 && (
                  <Form.Text className="text-danger">
                    {lang[13]} https://me-qr.com/
                  </Form.Text>
                )}
            </Col>
          </Row>
        );
      })}
    </>
  );

  return (
    <>
      {isLogoModal && <ModalLogo setLogo={setLogo} />}
      <Row className="mb-2 g-3">
        {defaultLogo.slice(0, 8).map((item) => {
          return (
            <CustomCol xs={3} key={item.id}>
              <FrameItem
                onClick={() => {
                  if (
                    !configData.socials.some((social) => social.id === item.id)
                  ) {
                    dispatch(
                      updateBuilderSocialLinks([
                        ...configData.socials,
                        { id: item.id, link: "" },
                      ])
                    );
                  }
                }}
                className={classNames(
                  "d-flex justify-content-center align-items-center border rounded-1 p-2",
                  {
                    "border-primary": configData.socials.some(
                      (social) => social.id === item.id
                    ),
                    "border-border-gray": !configData.socials.some(
                      (social) => social.id === item.id
                    ),
                  }
                )}
              >
                <img src={item.img} id={item.id} className="img-fluid h-100" />
              </FrameItem>
            </CustomCol>
          );
        })}
      </Row>
      <div
        className="text-primary fs-7 text-center mb-4 mt-3 bg-white text-capitalize cursor-pointer"
        onClick={handleViewMore}
      >
        {langLogo[2]}
      </div>
      {addSocialLink()}
    </>
  );
});

const Logo = styled.div`
  svg {
    width: 16px;
    height: 16px;
  }
`;

export const FrameItem = styled.div`
  svg {
    width: ${(props) => (props.svgSize ? `${props.svgSize}%` : "100%")};
    height: ${(props) => (props.svgSize ? `${props.svgSize}%` : "100%")};
  }
`;

const CustomCol = styled(Col)`
  @media (min-width: 992px) {
    width: 12.5% !important;
  }
`;
